export const API_URL =
  "https://us-central1-firebasecupominauguracao.cloudfunctions.net/api";
